import React from "react";
import Layout from "../../components/Layout";
import OpenGraphTitle from "../../components/OpenGraphTitle";
import OpenGraphDescription from "../../components/OpenGraphDescription";
import Head from "../../components/head";
import { ServicesPageProvider } from "../../context/ServicesPageContext";
import { FranchiseeProvider } from "../../context/Franchisee";
import ServiceTitle from "../../components/ServiceTitle";
import { Col, Row } from "react-bootstrap";
import Link from "next/link";
import ContactUs from "../../components/ContactUs";

interface OneTimeCleanPageProps {
  /* add services page props here */
}

const OneTimeClean: React.FC<OneTimeCleanPageProps> = () => (
  <FranchiseeProvider>
    <ServicesPageProvider>
      <Layout alternateFooter={true}>
        <Head
          slug="one-time-clean"
          title="Design With Time - One Time Cleaning Services - Two Maids"
          description="One-time cleaning services that fit your needs are our specialty. With Design With Time, your one time cleaning priorities are handled in order."
        />
        <OpenGraphTitle title="Design With Time - One Time Cleaning Services - Two Maids" />

        <OpenGraphDescription>
          One-time cleaning services that fit your needs are our specialty. With Design With Time, your one time cleaning priorities are handled in order.
        </OpenGraphDescription>

        <ServiceTitle imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955998/hubsite-reskin/New%20Services%20Pages/design-with-time.webp">One Time Cleaning</ServiceTitle>
        <div className="service-description gray-background">
          <Row className="pb-3">
            <Col sm={12} md={6}>
              <h2>Design with Time <br />Cleaning Service</h2>
              <h3 className="service-description-title">One Time Cleaning Services Tailored to You</h3>
              <p>
                the Design with Time Cleaning Package, specifically tailored
                for those seeking flexibility in their cleaning service whether it's
                in preparation for a special event or just a helping hand for
                everyday life. This package is designed to fit seamlessly into
                your schedule, offering a personalized cleaning experience that
                prioritizes your most important needs.
              </p>
            </Col>
            <Col sm={12} md={6}>
              <h3 className="service-description-title">What You Can Expect From Our Design With Time One-Time Cleaning Service</h3>
              <p>
                <b className="gotham-bold">Tailored Time Slots</b> Choose from 2 to 5 hours of dedicated cleaning time, fitting
                around your schedule and requirements, with a fixed cleaning cost to match.
              </p>
              <p>
                <b className="gotham-bold">Customized Professional Cleaning Focus</b> You decide which areas of your
                home you want us to spend the most time cleaning and whether they
                require a light or detailed cleaning approach.
              </p>
              <p>
                <b className="gotham-bold">Expert House Cleaning Service Team</b> Two experienced house cleaners will 
                be assigned to your home, equipped with the cleaning supplies and 
                expertise to deliver a superior cleaning experience.
              </p>
              <p>
                <b className="gotham-bold">Efficient and Effective</b> Our home cleaning service team will tackle your
                priority list, striving to complete all tasks within the purchased time frame.
              </p>
            </Col>
          </Row>
        </div>
        <div className="service-description mb-4">
          <div className="mb-4">
            <h3 className="service-description-title">Flexibility and Control in Your Hands</h3>
            <p>
              Our Design with Time Cleaning Package is the epitome of a tailored maid service, providing you with the ability to dictate the
              duration and focus of the cleaning session. Available in fixed-rate blocks ranging from 2 to 5 hours, this package allows you to
              specify exactly how long you want our team in your home. Two dedicated professional house cleaners  will be assigned to your
              home, working diligently to address your cleaning checklist priorities in order of importance.
            </p>
          </div>
          <div className="mb-4">
            <h3 className="service-description-title">One Time Cleaning Service - Ideal for Every Occasion</h3>
            <p>
              The Design with Time Package is perfect for those with a busy schedule, cleaning needs that regular cleaning just won't cover, or a specific
              cleaning checklist that doesn't require a full, deep clean. Whether you're preparing for guests, need a post-event clean-up, or simply want to
              refresh certain areas of your home without committing to a comprehensive standard cleaning package, Design with Time offers the solution.
            </p>
          </div>
          <div className="mb-4">
            <h3 className="service-description-title">Prioritize Your Home Cleaning Needs</h3>
            <p>
              Understanding that time is of the essence, we allow you to set the agenda. Whether your focus is on the kitchen, bathrooms,
              bedrooms, or common areas, you have the flexibility to define what areas require the most attention and whether each area should
              receive a light touch-up or a more detailed clean.
            </p>
          </div>
          <div>
            <h3 className="service-description-title">Our Commitment to Satisfaction</h3>
            <p>
              At Two Maids, your satisfaction is our top priority. We understand the trust you place in us when you open your home for cleaning.
              Every professional on our team is committed to respecting your space and priorities, delivering a sparkling home in the most
              efficient manner possible. We strive to complete your entire list within the allocated time. Our focus is always on quality and
              thoroughness so that your most important areas are addressed to your satisfaction within the time you have purchased.
            </p>
          </div>
        </div>
        <ContactUs
          title="Ready to Design Your Clean?"
          className="contact-us-flex"
          buttons={
            <Row className="d-flex justify-content-center">
              <Col md={"auto"} className="mb-3">
                <Link href={process.env.SALES_FUNNEL_URL}>
                  <a className="contact-us-button">BOOK YOUR CLEANING</a>
                </Link>
              </Col>
              <Col md={"auto"}>
                <Link href={process.env.SALES_FUNNEL_URL}>
                  <a className="contact-us-button">CALCULATE YOUR PRICE</a>
                </Link>
              </Col>
            </Row>
          }
        >
          <p>
            Embrace the flexibility and control of our Design with Time Cleaning Package 
            and enjoy a cleaning service that adapts to your life, not the other way 
            around. Let Two Maids help you maintain a clean and welcoming home on 
            your terms. And, if you need more specific services, there are other one-time 
            cleaning options as well, such as our Move In & Move Out service and our 
            Deep Cleaning Service. Contact us today to schedule your personalized 
            cleaning session and experience the peace of mind that comes with a 
            clean space, designed just for you.
          </p>
        </ContactUs>
      </Layout>
    </ServicesPageProvider>
  </FranchiseeProvider>
);
export default OneTimeClean;
